<template>
  <modal
    title="Edit Sales Data"
    width="45"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="flex flex-col">
      <div class="flex flex-wrap justify-between pt-6">
        <div class="w-5/12 mt-2">
          <label class="w-full">Sales (₦ - Excl. Tax):</label>
          <input class="input-field" />
        </div>
        <div class="w-5/12 mt-2">
          <label class="w-full">Tax (₦):</label>
          <input class="input-field" />
        </div>
        <div class="w-5/12 mt-2">
          <label class="w-full">Sales (₦ - Incl. Tax):</label>
          <input class="input-field" />
        </div>
      </div>

      <div class="flex flex-wrap mt-6 p-2 bg-gray-100 border-gray-300 border-2 rounded justify-between">
           <div class="split-sales">
              <p class="opacity-50">Previously Added Value:</p>
              <p class="border-b-2 border-gray-300 py-2">Sales: ₦ 1,000,000</p>
              <p>Tax:  ₦ 50,000</p>
           </div>

           <div class="split-sales">
            <p class="opacity-50">Difference</p>
            <p class="border-b-2 border-gray-300 py-2">Sales:  + ₦ 0.00</p>
            <p>Tax:   + ₦ 0.00</p>
         </div>
      </div>

      <div class="flex items-center justify-between mt-8">
        <button>cancel</button>
        <base-button
          buttonText="save"
          :disabled="disableButton"
          @click="createUser"
          :loading="creatingUser"
        />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      disableButton: false
    };
  },
  methods: {
    createUser() {
      //
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.input-field {
  @apply py-2 px-2 rounded border-2 border-gray-200;
}
.split-sales{
    width: 48%;
}
</style>
